import { tool } from "ai";
import { z } from "zod";
import { PROXY_URL, getTodayDate } from "./shared";

export default tool({
  description: "Retrieves sales forecast for future dates.",
  parameters: z.object({
    from: z.string().describe("Start date in YYYY-MM-DD format"),
    to: z
      .string()
      .describe("Ending date in YYYY-MM-DD format")
      .default(getTodayDate()),
    country: z.string().describe("Two letter country code").default("NL"),
    channel: z
      .enum(["Remote", "Online", "Store", ""])
      .describe(
        "Sales channel. If the user does not mention any sales channel then it is omitted"
      )
      .optional()
      .or(z.null()),
    timeframe: z
      .enum(["year", "month", "week"])
      .describe(
        "The timeseries data requested can be in yearly, monthly or weekly periods. This parameter defines that"
      )
      .default("year"),
  }),
  execute: async ({ from, to, country, channel, timeframe }) => {
    const searchParams = new URLSearchParams({
      from,
      to,
      select: `created_net_revenue.sum()${channel ? `,sales_channel` : ""}`,
      timeframe,
      identifier: `country.eq('${country}')`,
    }).toString();

    const url = `${PROXY_URL}/ts-sales-forecast-api/v1/sales?${searchParams}`;
    const results = await fetch(url);
    const json = await results.json();
    return json;
  },
});
